import React, { useEffect } from 'react';

const BoardHome = () => {

  useEffect(() => {
  }, []);

  return (
    <div className="container" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
        <h3>SmartElec web application</h3>
        <div style={{marginTop: "1rem"}}>
          <img src="/app/web_hi_res_512.png"></img>
        </div>
    </div>
  );
};

export default BoardHome;
